<template>
  <div class="modal fade" id="modalCapturarDatosSentencia" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Captura de Datos de Sentencia</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <br />
          <div class="row new-row">
            <div class="col-12">
              <h5>Fecha de Sentencia:</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <input type="date" class="form-control" v-model="fechaDeSentencia" />
            </div>
          </div>
          <div class="row new-row">
            <div class="col-12">
              <h5>Sentido de la Sentencia:</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <C003TiposDeSentidoDeSentencia v-on:valorParaElPadre="cambioTipoDeSentidoDeSentencia"
                                             :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                             :tipo="enumeraciones.tiposDeSelect.Seleccione"
                                             :idDelInput="'catalogoTipoDeSentidoDeSentencia'"
                                             :parametros="parametros_TipoDeSentidoDeSentencia"
                                             :valorDefinido="parametros_TipoDeSentidoDeSentencia.valorDefinido">
              </C003TiposDeSentidoDeSentencia>
            </div>
          </div>
          <div class="row new-row">
          <div class="col-12">
            <h5>Sanción:</h5>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <input type="text" class="form-control" v-model="sancion" />
          </div>
        </div>


      </div>
        <div class="modal-footer">
          <button type="button"
                  class="btn btn-primary"
                  data-dismiss="modal"
                  @click="guardarSentencia" :disabled="deshabilitarBotonGuardarSentencia">
            Aceptar
          </button>
          <button type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal">
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';
  import catalogos from '@/../static/js/catalogos'
  import store from '@/store/index'

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        catalogos,
        fechaDeSentencia: null,
        parametros_TipoDeSentidoDeSentencia: {
          valorDefinido: -1,
          tipoDeSentidoDeSentenciaId: null,
          conInactivas: false,
          esFinal: true
        },
        sancion: ""
      }
    },
    props: {
      quejaAdministrativaId: Number,
    },
    mounted() {
      
    },
    components: {
      C003TiposDeSentidoDeSentencia: catalogos.SIQA.C003TiposDeSentidoDeSentencia,
    },
    methods: {
      guardarSentencia: function () { //Retorna una lista de citas 'Aceptadas'
        var peticion = {
          "esPrueba": false,
          "quejaAdministrativaId": this.quejaAdministrativaId,
          "fechaSentencia": this.fechaDeSentencia,
          "tipoDeSentidoDeSentenciaId": this.parametros_TipoDeSentidoDeSentencia.tipoDeSentidoDeSentenciaId,
          "sancion": this.sancion
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIQA.funciones.GuardarDatosDeSentencia, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          comun.SeEstaCargandoInformacion(true);
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.$emit("valorParaElPadre", this.quejaAdministrativaId);
            comun.mensajeDeAlerta(response.data.Satisfactorio)
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          comun.SeEstaCargandoInformacion(false);
        });
      },
      cambioTipoDeSentidoDeSentencia(datos) { //Administra los cambios en el componente de Área
        catalogos
        this.parametros_TipoDeSentidoDeSentencia.tipoDeSentidoDeSentenciaId = parseInt(datos[0].target.value)
      },
    },
    created() {

    }, computed: {
      deshabilitarBotonGuardarSentencia: function () {
        return this.quejaAdministrativaId === -1 || !this.fechaDeSentencia || this.sentidoDeSentenciaInvalido || !this.sancion;
      },
      sentidoDeSentenciaInvalido: function () {
        return !this.parametros_TipoDeSentidoDeSentencia.tipoDeSentidoDeSentenciaId || this.parametros_TipoDeSentidoDeSentencia.tipoDeSentidoDeSentenciaId === -1
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SIQA/QuejasAdministrativas/QuejasPendientes/ModalCapturaDatosSentencia.vue